import { fetchTdLte } from 'api';
import React from 'react';
import { useQuery } from 'react-query';

function useTdLteFetch() {
  return useQuery({
    queryKey: ['td-lte'],
    queryFn: fetchTdLte,
  });
}

export default useTdLteFetch;
